import React from "react";
import { cn, formControlTextareaClass } from "./formStyles";

const TextAreaInput = React.forwardRef(function TextAreaInput(
  { className = "", invalid = false, ...props },
  ref
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        formControlTextareaClass,
        invalid && "border-red-500 focus:ring-red-500",
        className
      )}
      {...props}
    />
  );
});

export default TextAreaInput;
